const trashRedIcon = `
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.125 11.7788H10.8654M31.875 11.7788H29.1346M24.5673 11.7788H15.4327M24.5673 11.7788V9.95192C24.5673 8.94294 23.7494 8.125 22.7404 8.125H17.2596C16.2506 8.125 15.4327 8.94294 15.4327 9.95192V11.7788M24.5673 11.7788H29.1346M15.4327 11.7788H10.8654M29.1346 11.7788V28.2212C29.1346 30.2391 27.4987 31.875 25.4808 31.875H14.5192C12.5013 31.875 10.8654 30.2391 10.8654 28.2212V11.7788" stroke="#C9CCCD" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export default trashRedIcon;
